module.exports = __webpack_public_path__ + "37ba7b92/img/ion_calendar-number.3ac5bd07.svg";